import client from '@/graphql/client'
import AddEnterpriseCustomer from '@/graphql/mutations/AddEnterpriseCustomer'
import AddEnterpriseMember from '@/graphql/mutations/AddEnterpriseMember'
import RemoveEnterpriseMemberByAdmin from '@/graphql/mutations/RemoveEnterpriseMemberByAdmin'
import RemoveEnterpriseCustomer from '@/graphql/mutations/RemoveEnterpriseCustomer'
import ChangeEnterprisePayer from '@/graphql/mutations/ChangeEnterprisePayer'
import ListEnterpriseCustomers from '@/graphql/queries/ListEnterpriseCustomers'
import UpdateEnterpriseCustomer from '@/graphql/mutations/UpdateEnterpriseCustomer'

export const enterpriseCustomers = {
  namespaced: true,
  state: {
    enterpriseCustomers: [],
    loadingEnterpriseCustomers: false,
    loadingAddEnterpriseCustomer: false,
    loadingUpdateEnterpriseCustomer: false,
    loadingAddEnterpriseMember: false,
    loadingRemoveEnterpriseMember: false,
    loadingChangeEnterprisePayer: false

  },
  mutations: {
    setEnterpriseCustomers (state, enterpriseCustomers) {
      state.enterpriseCustomers = enterpriseCustomers
    },
    setLoadingEnterpriseCustomers (state, loadingEnterpriseCustomers) {
      state.loadingEnterpriseCustomers = loadingEnterpriseCustomers
    },
    setLoadingAddEnterpriseCustomer (state, loadingAddEnterpriseCustomer) {
      state.loadingAddEnterpriseCustomer = loadingAddEnterpriseCustomer
    },
    setLoadingUpdateEnterpriseCustomer (state, loadingUpdateEnterpriseCustomer) {
      state.loadingUpdateEnterpriseCustomer = loadingUpdateEnterpriseCustomer
    },
    setLoadingAddEnterpriseMember (state, loadingAddEnterpriseMember) {
      state.loadingAddEnterpriseMember = loadingAddEnterpriseMember
    },
    setLoadingRemoveEnterpriseMember (state, loadingRemoveEnterpriseMember) {
      state.loadingRemoveEnterpriseMember = loadingRemoveEnterpriseMember
    },
    setLoadingChangeEnterprisePayer (state, loadingChangeEnterprisePayer) {
      state.loadingChangeEnterprisePayer = loadingChangeEnterprisePayer
    }
  },
  actions: {
    async listEnterpriseCustomers ({ commit, state, rootGetters, dispatch }) {
      try {
        commit('setLoadingEnterpriseCustomers', true)
        let allItems = []
        let nextToken = null

        do {
          const res = await client.query({
            operationName: 'listEnterpriseCustomers',
            query: ListEnterpriseCustomers,
            variables: { limit: 100, nextToken }
          })
          const data = res?.listEnterpriseCustomers
          allItems = allItems.concat(data?.items || [])
          nextToken = data?.nextToken
        } while (nextToken)

        commit('setEnterpriseCustomers', allItems)
        commit('setLoadingEnterpriseCustomers', false)
        return allItems
      } catch (e) {
        console.log(e)
        commit('setLoadingEnterpriseCustomers', false)
        commit('snackbar/showMessage', {
          content: 'Error, try again!',
          timeout: 6000,
          color: 'red',
          location: 'center center'
        }, { root: true })
      }
    },
    async addEnterpriseCustomer ({ commit, state, rootGetters, dispatch }, {
      company,
      startDate,
      expirationDate,
      quantity,
      payerUserEmail,
      payerUserId
    }) {
      try {
        commit('setLoadingAddEnterpriseCustomer', true)
        const variables = {
          company,
          startDate,
          expirationDate,
          quantity,
          payerUserEmail
        }
        if (payerUserId) {
          variables.payerUserId = payerUserId
        }
        const res = await client.query({
          operationName: 'addEnterpriseCustomer',
          query: AddEnterpriseCustomer,
          variables
        })
        commit('setLoadingAddEnterpriseCustomer', false)
        return res.addEnterpriseCustomer
      } catch (e) {
        console.log(e)
        commit('setLoadingAddEnterpriseCustomer', false)
        commit('snackbar/showMessage', {
          content: 'Error, try again!',
          timeout: 6000,
          color: 'red',
          location: 'center center'
        }, { root: true })
      }
    },
    async updateEnterpriseCustomer ({ commit, state, rootGetters, dispatch }, {
      enterpriseUserId,
      input
    }) {
      try {
        commit('setLoadingUpdateEnterpriseCustomer', true)
        const res = await client.query({
          operationName: 'updateEnterpriseCustomer',
          query: UpdateEnterpriseCustomer,
          variables: { enterpriseUserId, input }
        })
        const result = res.updateEnterpriseCustomer

        const updatedEnterpriseCustomers = state.enterpriseCustomers.map(customer => {
          if (customer.id === result.id) {
            return { ...customer, ...result }
          }
          return customer
        })
        commit('setEnterpriseCustomers', updatedEnterpriseCustomers)
        commit('setLoadingUpdateEnterpriseCustomer', false)
        return res.updateEnterpriseCustomer
      } catch (e) {
        console.log(e)
        commit('setLoadingUpdateEnterpriseCustomer', false)
        commit('snackbar/showMessage', {
          content: 'Error, try again!',
          timeout: 6000,
          color: 'red',
          location: 'center center'
        }, { root: true })
      }
    },
    async addEnterpriseMember ({ commit, state, rootGetters, dispatch }, {
      email,
      payerUserId,
      enterpriseCustomerId
    }) {
      try {
        commit('setLoadingAddEnterpriseMember', true)
        const variables = { email }
        if (payerUserId) {
          variables.payerUserId = payerUserId
        }
        if (enterpriseCustomerId) {
          variables.enterpriseCustomerId = enterpriseCustomerId
        }
        const res = await client.query({
          operationName: 'addEnterpriseMember',
          query: AddEnterpriseMember,
          variables
        })
        const result = res.addEnterpriseMember
        commit('setLoadingAddEnterpriseMember', false)
        return result
      } catch (e) {
        console.dir(e)
        commit('setLoadingAddEnterpriseMember', false)
        commit('snackbar/showMessage', {
          content: e.message,
          timeout: 6000,
          color: 'red',
          location: 'center center'
        }, { root: true })
      }
    },
    async removeEnterpriseMemberByAdmin ({ commit }, { email, payerUserId }) {
      try {
        commit('setLoadingRemoveEnterpriseMember', true)
        const variables = { email }
        if (payerUserId) {
          variables.payerUserId = payerUserId
        }
        const res = await client.query({
          operationName: 'removeEnterpriseMemberByAdmin',
          query: RemoveEnterpriseMemberByAdmin,
          variables
        })
        const result = res.removeEnterpriseMemberByAdmin
        commit('setLoadingRemoveEnterpriseMember', false)
        return result
      } catch (e) {
        console.dir(e)
        commit('setLoadingRemoveEnterpriseMember', false)
        commit('snackbar/showMessage', {
          content: e.message,
          timeout: 6000,
          color: 'red',
          location: 'center center'
        }, { root: true })
      }
    },
    async removeEnterpriseCustomer ({ commit, state }, { enterpriseCustomerId }) {
      try {
        const res = await client.query({
          operationName: 'removeEnterpriseCustomer',
          query: RemoveEnterpriseCustomer,
          variables: { enterpriseCustomerId }
        })
        const result = res.removeEnterpriseCustomer
        if (result?.success) {
          const remaining = state.enterpriseCustomers.filter((customer) => customer.id !== enterpriseCustomerId)
          commit('setEnterpriseCustomers', remaining)
        }
        return result
      } catch (e) {
        console.dir(e)
        commit('snackbar/showMessage', {
          content: e.message,
          timeout: 6000,
          color: 'red',
          location: 'center center'
        }, { root: true })
      }
    },
    async changeEnterprisePayer ({ commit, dispatch }, { enterpriseCustomerId, newPayerUserEmail, newPayerUserId }) {
      try {
        commit('setLoadingChangeEnterprisePayer', true)
        const variables = { enterpriseCustomerId, newPayerUserEmail }
        if (newPayerUserId) {
          variables.newPayerUserId = newPayerUserId
        }
        const res = await client.query({
          operationName: 'changeEnterprisePayer',
          query: ChangeEnterprisePayer,
          variables
        })
        const result = res.changeEnterprisePayer
        if (result?.success) {
          await dispatch('listEnterpriseCustomers')
        }
        commit('setLoadingChangeEnterprisePayer', false)
        return result
      } catch (e) {
        console.dir(e)
        commit('setLoadingChangeEnterprisePayer', false)
        commit('snackbar/showMessage', {
          content: e.message,
          timeout: 6000,
          color: 'red',
          location: 'center center'
        }, { root: true })
      }
    }
  }
}
